import React, { StrictMode } from "react";
import ReactDOM from "react-dom";
import App3 from "./App3";

ReactDOM.render(<App3 />, document.getElementById("root"));
